export const subadminsKey = "subadmins";
export const subadminRolesKey = "subadminRoles";
export const informationPolicyKey = "informationPolicy";
export const categoriesKey = "categories";
export const pagesKey = "Pages";
export const bannerKey = "banners";
export const adminSettingsKey = "adminSettings";
export const configSettingsKey = "configSettings";
export const userKey = "user";
export const notificationKey = "notificationKey";
export const categoryQuestionsKey = "categoryQuestions";
export const clientKey = "client";
export const staffKey = "staff";
export const staffRolesKey = "staffRoles";
export const ratingKey = "rating";
export const googleReviewsKey = "googleReviews";
export const categoryKey = "category";
export const templateKey = "template";
export const reviewUrlKey = "reviewUrl";
export const feedbackTypesKey = "feedbackTypes";
export const issueKey = "issues";
export const visitLocationKey = "visitLocations";
export const inboxKey = "inbox";
export const trendsKey = "departmentTrends";
